export { default } from './ThirdScene';
